import { useState, useEffect } from "react";
import { Box, Button, Image, Input, Stack, Text } from "@chakra-ui/react";
import { Field } from "../ui/field";
import { PasswordInput } from "../ui/password-input";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../Redux/Action/auth/loginAction";
import logoOnDark from "../../Images/globalapex-logo-dark.png";
import logoOnLight from "../../Images/globalapex-logo-light.png";
import { getWhitelabels } from "../../Redux/Action";
import { getLocalStorageItem } from "../../Utils/Helper"
import { useTheme } from "next-themes";

export const LoginForm = () => {
  const dispatch = useDispatch();
  const { resolvedTheme } = useTheme();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [isDisabled, setIsDisabled] = useState(false);
  const loading = useSelector((state) => state?.GetWhiteLabel?.loading);
  const [logoSrc, setLogoSrc] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { email, password } = formData;
    let hasError = false;

    if (!email) {
      setErrors((prev) => ({ ...prev, email: "Username is required" }));
      hasError = true;
    }
    if (!password) {
      setErrors((prev) => ({ ...prev, password: "Password is required" }));
      hasError = true;
    }

    const whitelabelLocalStorage = getLocalStorageItem("whitelabelData");
    if (whitelabelLocalStorage !== null) {
      formData.whiteLabelId = whitelabelLocalStorage._id;
    }

    if (!hasError) {
      let payload = formData;

      dispatch(
        login({
          payload,
          callback: (data) => {
            if (data.meta.code === 200) {
              setIsDisabled(false);
            } else {
              setIsDisabled(false);
            }
          },
        })
      );
    }
  };

  useEffect(() => {
    const whitelabelData = getLocalStorageItem("whitelabelData");

    if (!loading) {
      const selectedLogo =
        whitelabelData && resolvedTheme === "dark"
          ? whitelabelData.logo_dark
          : whitelabelData?.logo_light;

      setLogoSrc(selectedLogo || (resolvedTheme === "dark" ? logoOnDark : logoOnLight));
    }
  }, [loading, resolvedTheme]);

  useEffect(() => {
    const { email, password } = formData;
    if (email && password && !errors.email && !errors.password) {
      setIsDisabled(false);
    }
  }, [formData, errors]);

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "420px" }}>
      <Stack
        gap="5"
        align="stretch"
        width="100%"
        bg="bg.surface"
        border="1px solid"
        borderColor="border.subtle"
        borderRadius="2xl"
        boxShadow="card"
        padding={{ base: "6", md: "10" }}
      >
        {!loading && logoSrc && (
          <Image src={logoSrc} alt="Logo" maxH="64px" objectFit="contain" alignSelf="center" />
        )}

        <Box textAlign="center" mb={1}>
          <Text fontSize="xl" fontWeight="600" color="fg.default" letterSpacing="-0.01em">
            Sign in to Admin Console
          </Text>
          <Text fontSize="sm" color="fg.muted" mt={1}>
            Enter your credentials to continue
          </Text>
        </Box>

        <Field label="Email/Username" invalid={!!errors.email} errorText={errors.email}>
          <Input name="email" value={formData.email} onChange={handleChange} />
        </Field>

        <Field
          label="Password"
          invalid={!!errors.password}
          errorText={errors.password}
        >
          <PasswordInput
            name="password"
            value={formData.password}
            onChange={handleChange}
          />
        </Field>

        <Button
          type="submit"
          disabled={isDisabled}
          width="100%"
          mt={1}
          bg="brand.600"
          color="white"
          _hover={{ bg: "brand.700" }}
        >
          Sign in
        </Button>
      </Stack>
    </form>
  );
};
